module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am6-210409c668b62f994c3347354b27b2c5.jpg";